<div
  style="background-image: url('assets/sign-up-bg.svg')"
  class="seller-signup h-screen overflow-y-auto bg-[#BBDEEB] bg-cover bg-no-repeat bg-center text-gray"
>
  <div class="container mx-auto flex justify-center px-4 sm:px-17.5 pt-12 relative">
    <sham-i-sham-logo-Full class="px-2 absolute top-4 xl:inset-s-17.5 inset-s-12" />
    <div
      class="max-w-[717px] xl:w-[717px] p-8 pb-10.5 rounded bg-white-light space-y-4"
    >
      <h2 class="font-semibold text-[32px] leading-[24px] p-2.5 text-center mb-4">
        Join Our Marketplace
      </h2>
      <nav
        class="px-4 border rounded-lg h-12 flex justify-center items-stretch gap-x-6 pt-1 *:flex *:items-center *:justify-center *:transition-colors"
      >
        <a
          [ngClass]="{
            'border-b border-blue-dark text-blue-dark': isActiveRoute('personal-info'),
            'cursor-pointer': manager.hasApplication(),
            'cursor-not-allowed': !manager.hasApplication(),
          }"
          class="step-link"
          [routerLink]="manager.hasApplication() ? ['personal-info'] : null"
        >
          Personal Info
        </a>
        <a
          [ngClass]="{
            'border-b border-blue-dark text-blue-dark': isActiveRoute('company-info'),
            'cursor-pointer': manager.hasApplication(),
            'cursor-not-allowed': !manager.hasApplication(),
          }"
          class="step-link"
          [routerLink]="manager.hasApplication() ? ['company-info'] : null"
        >
          Company Info
        </a>
        <a
          [ngClass]="{
            'border-b border-blue-dark text-blue-dark': isActiveRoute('store-profile'),
            'cursor-pointer': manager.hasApplication(),
            'cursor-not-allowed': !manager.hasApplication(),
          }"
          class="step-link"
          [routerLink]="manager.hasApplication() ? ['store-profile'] : null"
        >
          Store Profile
        </a>
        @if (manager.showFeedback()) {

        <a 
            [ngClass]="{ 'border-b border-blue-dark text-blue-dark': isActiveRoute('feedback') }"
            class="step-link"
            [routerLink]="['feedback']"
          >
            Feedback
          </a>
        }
      </nav>
      <router-outlet />
    </div>
  </div>
  <div class="page-footer-copy text-center text-[#6D6D6D] mt-5">
    All rights reserved © Shamsuperstore.com
  </div>
</div>
